import axios from "axios";

const axiosClient = axios.create({
    baseURL: `${process.env.REACT_APP_API_BASE_URL}/api`,
    headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
    },
});

// Request Interceptor
axiosClient.interceptors.request.use((config) => {
    const token = localStorage.getItem("ACCESS_TOKEN");
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
}, (error) => {
    return Promise.reject(error);
});

// Response Interceptor
axiosClient.interceptors.response.use(
    (response) => {
        return response;
    },
    (error) => {
        if (error.response) {
            // Handle known errors (like 401, 403, 404, etc.)
            if (error.response.status === 401) {
                localStorage.removeItem("ACCESS_TOKEN");
                // You can redirect to the login page if needed
                // window.location.href = "/login";
            } else if (error.response.status === 403) {
                // Handle Forbidden Error
                console.error("Access forbidden: ", error.response.data);
            } else if (error.response.status === 404) {
                // Handle Not Found Error
                console.error("Resource not found: ", error.response.data);
            } else if (error.response.status === 422) {
                // Handle Not Found Error
                console.error("Resource not found: ", error.response.data);
            } else {
                // Handle other errors
                console.error("An error occurred: ", error.response.data);
            }
        } else {
            // Handle errors that don't have a response (like network issues)
            console.error("Network error: ", error.message);
        }
        return Promise.reject(error);
    }
);

export default axiosClient;
